import { Button } from '@bpinternal/ui-kit-next'
import { createFileRoute, Link, Outlet } from '@tanstack/react-router'
import { Plus } from 'lucide-react'
import { ComponentProps } from 'react'
import { Boundary, Page } from '~/components'
import { useCurrentRouteId } from '~/hooks'
import { NavbarActionsProvider, useNavbarActions } from '~/providers/NavbarACtionsContext'

function NavbarActionsConsumer() {
  const { navbarActions } = useNavbarActions()
  return <>{navbarActions}</>
}

export const Route = createFileRoute('/workspaces/$workspaceId/usage')({
  component: Component,
})

function Component() {
  const { workspaceId } = Route.useParams()
  const currentRouteId = useCurrentRouteId() ?? ''

  const items: ComponentProps<typeof Page>['navbarItems'] = [
    {
      children: 'Workspace',
      to: '/workspaces/$workspaceId/usage/monthly-summary',
    },
    {
      children: 'Bot',
      to: '/workspaces/$workspaceId/usage/ai-spend',
    },
  ]

  const itemsWithActiveState = items.map((i) => ({
    ...i,
    active: currentRouteId.includes(i?.to ?? 'not-a-path'),
  }))

  return (
    <NavbarActionsProvider>
      <Page
        title="Usage"
        actions={
          <Link to={'/workspaces/$workspaceId/billing'} params={{ workspaceId }}>
            <Button>
              <Plus />
              Increase Limits
            </Button>
          </Link>
        }
        navbarItems={itemsWithActiveState}
        navbarActions={<NavbarActionsConsumer />}
      >
        <Boundary>
          {/* TODO: Add Skeleton loading screen */}
          <Outlet />
        </Boundary>
      </Page>
    </NavbarActionsProvider>
  )
}
